import {EventStore} from "../../server/EventStore.js";
import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as amplify from "../../util/amplify.ts";
import TPL_search from "../../calendar/searchresult.mustache";
import {easyScorer, applyScorer } from "../searchController.js";
import IHasRecurrencyHelper from "../../lib/IHasRecurrencyHelper.js"
export {init}



Html.registerWidget('widget/specific/calendarsearch',{init:init})

Html.register({
  eventopensearch:function(){
    Html.triggerbystring(this,'addparentclass|flexrow|showsearch');
    this.prev().find('input[type=search]').select()
    
  }
})

var currentDate = new Date();
amplify.subscribe('calendar.currentDate',function(newCurrentDate){
  currentDate = newCurrentDate
})
function CloseToNowComparator(a,b){
  return Math.abs(a.startDate-currentDate)-Math.abs(b.startDate-currentDate)
}

var scorer = easyScorer({text:4,description:2})
function init(obj){
  var resultNode = obj.parent().find('div');
  obj.on('input',function(evt){
    var searchText = obj.val().trim();
    if(searchText.length>1){
      EventStore.getFor(undefined).then(function(events){
        
        events = events.map(ev=>{
          var closest = IHasRecurrencyHelper.getClosest(ev,currentDate)
          FwDatas.cache(closest)
          return closest;
        })
         let filtered = applyScorer(events, scorer, searchText).slice(0,30);
        filtered.sort(CloseToNowComparator)
        Html.setHtml(resultNode,TPL_search,filtered);
        resultNode.show();
      })  
    }else{
      resultNode.hide();
    }
  })
}